function AnalysisRenderer({

  blocks = []

}) {

  return (

    <div className="analysis-renderer">

      {

        blocks.map(block => {

          // STYLE
          const style = {

            color:
              block.style?.color,

            textAlign:
              block.style?.textAlign,

            fontSize:
              block.style?.fontSize

          };

          // TITRE 1
          if (block.type === "title1") {

            return (

              <h1

                key={block.id}

                style={style}

              >

                {block.content}

              </h1>

            );

          }

          // TITRE 2
          if (block.type === "title2") {

            return (

              <h2

                key={block.id}

                style={style}

              >

                {block.content}

              </h2>

            );

          }

          // PARAGRAPHE
          if (block.type === "paragraph") {

            return (

              <p

                key={block.id}

                style={style}

              >

                {block.content}

              </p>

            );

          }

          // TABLEAU
          if (block.type === "table") {

            return (

              <table

                key={block.id}

                className="analysis-table"

              >

                <tbody>

                  {

                    block.tableData?.map(

                      (row, rowIndex) => (

                        <tr key={rowIndex}>

                          {

                            row.map(

                              (
                                cell,
                                colIndex
                              ) => (

                                <td
                                  key={colIndex}
                                >

                                  {cell}

                                </td>

                              )

                            )

                          }

                        </tr>

                      )

                    )

                  }

                </tbody>

              </table>

            );

          }

          return null;

        })

      }

    </div>

  );

}

export default AnalysisRenderer;